import React from 'react'
const Loader = () => {
  return (
        <div className="preLoaderOuter">
        <span className="loader"></span>
      </div>
  )
}

export default Loader;
